import mainTemplate from './views/base.tpl.html';
import listTemplate from './views/list.tpl.html';
import scannerTemplate from './views/scanner.tpl.html';
import detailsTemplate from './views/details.tpl.html';
import VoucherScannerController from "./controllers/scanner-controller";

angular
    .module('festzelt-os.vouchers.main')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.vouchers.main', {
            abstract: true,
            url: '/vouchers',
            templateUrl: mainTemplate,
            params: {
                back: 'app.vouchers.main.index',
                backParams: ['$stateParams', ($stateParams) => {
                    return {
                        store: $stateParams.store,
                    }
                }],
            },
            data: {
                showBackBtn: true,
                pageTitle: 'Vouchers'
            }
        })
        .state('app.vouchers.main.index', {
            url: '',
            sticky: true,
            data: {
                showBackBtn: false,
                view: 'list',
                rights: "vouchers::list"
            },
            views: {
                list: {
                    templateUrl: listTemplate,
                    controller: 'VouchersListCtrl',
                    controllerAs: 'vm'
                }
            }
        })
        .state('app.vouchers.main.scanner', {
            url: '/scanner',
            data: {
                showBackBtn: false,
                view: 'details',
                rights: "vouchers::scan-vouchers"
            },
            views: {
                details: {
                    templateUrl: scannerTemplate,
                    controller: VoucherScannerController,
                    controllerAs: 'vm'
                }
            }
        })
        .state('app.vouchers.main.details', {
            url: '/{vid}',
            params: {
                voucher: undefined,
                store: undefined
            },
            sticky: true,
            data: {
                view: 'details',
                rights: "vouchers::view"
            },
            views: {
                'details': {
                    templateUrl: detailsTemplate,
                    controller: 'VoucherDetailsCtrl',
                    controllerAs: 'vm'
                }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/main-routes.js